import {GET_EMPLOYEES_VACATION_REQUESTS} from "../../enums/Employees/employees.types";

export const getEmployeesVacationRequestsAction = (data) => {
    return {
        type: GET_EMPLOYEES_VACATION_REQUESTS,
        payload: data,
    };
};
